import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-input-group',
    templateUrl: './input-group.component.html',
    standalone: false
})
export class InputGroupComponent implements OnInit {

  @Input() label!: string;
  @Input() control!: FormControl;
  @Input() type!: string;

  ngOnInit() {
    this.type = this.type || 'text';
  }
}
